import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
//import "./Library.css";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { SBADropDown, SBAMultiSelect, SBAComboBox, SBAMultiSelectCheck, SBAMultiColumnComboBox,SBAMulticolumnCheck } from "../../UiComponents/SBADropDown";
import { DateRangePicker } from "rsuite";
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { AgGridReact } from 'ag-grid-react';
import { sbaAxios } from "../../utils/sbaAxios";
import { useParams, useLocation } from "react-router-dom";
import { getActivityDetail, getCategory, getActivityEntityType, getActivityType,getActivityEntities } from "../../actions/investmentAction";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getManagerContacts } from "../../actions/CommonAction";
import { getSubStrategy } from "../../actions/assetDetailsActions";
import { getPortfolioListAction } from '../../actions/portfolioListAction'
import { getAllUsers } from "../../actions/UserAction";
import { getAssetLists } from "../../actions/assetListAction";
import { insertOrUpdateActivityDetails, insertOrUpdateActivityDocument, deleteActivity, DeleteDocument, getActivityEntity, getActivityDetails, getDocumentStatus, getcategory, UpdateActivityDocumentname } from "../../../config/apiConfig";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { SBNotify } from "../../utils/sbNotify";
import { SBATextBox } from "../../UiComponents/SBATextBox";
import { Modal } from "react-bootstrap";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";

export const InvestorEdit = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();
    const Gstate = useSelector((state) => state) || {};
    const StrategyFillter = Gstate.subStrategy.subStrategy;
    const SubStrategy = StrategyFillter?.filter(item => item.ClassificationValue !== "--Please Select--")
    const managerFillter = Gstate.managerContacts.managerContacts;
    const manager = managerFillter?.filter(item => item.ManagerContact !== "--Please Select--")
    const users = useSelector((state) => state.Users.Users);
    const AssetListDDL = Gstate.assetList.assetList || [];
    const locationData = useLocation();
    const gridRef = useRef();
 
    // const ActivityDetailData = Gstate.activityDetail.activityDetail;
    // const activitySummary = ActivityDetailData?.ActivitySummary;
    // const activityDocuments = ActivityDetailData?.ActivityDocuments;
    // const activityref = ActivityDetailData?.ActivityXRefs;
    const [Category,setCategory]=useState([]);
    const [categoryFilter,setcategoryFilter]=useState([]);
  
    const [activitySummary,setActivitySummary] = useState([]);
    const [activityDocuments,setActivityDocuments] = useState([]);
    const [activityref,setActivityRef ]= useState([]);
    const [resulttrim, setResulttrim] = useState();
    const [selectedDocuments, setselectedDocuments] = useState([]);
   
    const ActivityentityType = useSelector((state) => state.ActivityentityType.ActivityentityType) || [];
    const [selectedEventDate, setselectedEventDate] = useState(null);
    const [EntityTypeIds, setEntityTypeIds] = useState();
   // const Entities = useSelector((state) => state.ActivityEntity.Activityentity) || [];
    const [Entities, setEntities] = useState();
    const [Status,setStatus]=useState([]);
    const[documentStatusId,setDocumentStatusId]=useState([]);
    
    const entitytypeids = activityref?.map(item => item.ActivityEntityTypeId).join(',');
    // const entitytypeid = entitytypeids === undefined ? 1 : null;
    const str = null;
    const [render, setRender] = useState(false);
    useEffect(() => {
        // dispatch(getActivityDetail(params.ActivityId, 2)); 
        getActivityDetail();
        // dispatch(getCategory(2));
      //  getCategoryData();
        dispatch(getManagerContacts());
        dispatch(getSubStrategy());
        dispatch(getPortfolioListAction());
        dispatch(getAllUsers());
        dispatch(getAssetLists());
        dispatch(getActivityType());
        dispatch(getActivityEntityType(2));
       
      
    }, []);
    // const Categoryfilter = useSelector((state) => state.Category.Category) || [];
    // const Category = Categoryfilter.filter(item => item.ActivitySubType !== "All")
  

    const ActivityTypefilter = useSelector((state) => state.ActivityType.ActivityType) || [];
    const ActivityType = ActivityTypefilter.filter(item => item.ActivityType !== "All")

    const [PartnerLetter, SetPartnerLetter] = useState(activityDocuments?.IsPartnerLetter);

    const [Entitytype, SetEntitytype] = useState();
    const [ExistingDocIds, SetExistingDocIds] = useState([activityDocuments?.map((item) => ({
        DocumentId: item.DocumentId,
    }))]);

  
    const initialAssetId = activityref;

    const [assetId, SetAssetId] = useState();
    const [isActivityProcessed, setIsActivityProcessed] = useState(false);
    

    const [subject, setsubject] = useState(null);
    const [ActivitySubTypeIds, setActivitySubTypeIds] = useState();

    const [comments, setcomments] = useState();

    const [ManagerLetter, SetManagerLetter] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const Level = [
        { BreadCrumb: "Investor >", Routes: `${UrlPath.DocumentInvestor}` },
    ];
    const [typeselected, setTypeSelected] = React.useState({ value: ActivityentityType, allSelected: true });
    //State  Variable.....

    const [activityDetailId, setActivityDetailId] = useState(null);
    const [selectedCategory,SetSelectedCategory]=useState();
    
    const initialEntity = ActivityType.filter(item => item.ActivityTypeId === activitySummary?.ActivityTypeId);
    useEffect(() => {
       
        SetExistingDocIds(activityDocuments?.map((item) => ({
            DocumentId: item.DocumentId,
        })))
        if (initialAssetId) {
            const mappedasset = initialAssetId?.map((item) => ({
                EntityId: item.EntityId,
                EntityName: item.EntityName,
                ActivityEntityTypeId: item.ActivityEntityTypeId,
                ActivityEntityType: item.ActivityEntityType,
            }));
            SetAssetId(mappedasset);
        }    
   
        // if (attach && attach.length > 0) {
        //     setActivitySubTypeIds({
        //         ActivitySubTypeId: attach[0]?.ActivitySubTypeId || '',
        //         ActivitySubType: attach[0]?.ActivitySubType || ''
        //     });
        // }
        if (initialEntity && initialEntity.length > 0) {
            SetEntitytype({
                ActivityTypeId: initialEntity[0]?.ActivityTypeId || '',
                ActivityType: initialEntity[0]?.ActivityType || ''
            });
        }      
           
            setselectedEventDate(activitySummary?.ActivityDate ? moment(activitySummary?.ActivityDate) : null);
      
        if (activityref && activityref.length>0) {
            if (activityref && activityref.length>0) {
                const mappedentities = activityref?.map((item) => ({
                    ActivityEntityTypeId: item.ActivityEntityTypeId,
           
                    ActivityEntityType : item.ActivityEntityType
                }));

          var filtereditems=ActivityentityType.filter(item=>item.ActivityEntityType.trim()!=="All")
          if(filtereditems .length===mappedentities.length)
          {
                setEntityTypeIds(ActivityentityType);
          }
          else
          {
            setEntityTypeIds(mappedentities);
          }
            }
          
        }
        setsubject(activitySummary?.ActivityName);
        setcomments(activitySummary?.ActivityDescriptionHtml);
       
    }, [activitySummary]);
    const getActivityDetail= async () => {
       
        try {
            const response =  await sbaAxios({
                url: `${getActivityDetails}${params.ActivityId},${2}`,
                method: 'get',
            });
            const data = response;
           setActivitySummary(data.ActivitySummary);
            setActivityDocuments(data.ActivityDocuments);
            setselectedDocuments(data.ActivityDocuments?.map((item) => ({
                DocumentId: item.DocumentId,
                DocumentName: item.DocumentName
            })))

           setActivityRef(data.ActivityXRefs);
           setIsActivityProcessed(data.ActivityDetails?.IsProcessed);
           
           const Ids=data.ActivityXRefs?.map(item => item.ActivityEntityTypeId).join(',');
            getEntities(Ids);
            getCategoryData(data.ActivitySummary.ActivitySubTypeId,data.ActivitySummary.ActivityTypeId);
            //setActivityDetailId(data);
            setActivityDetailId(data.ActivityDetails?.ActivityDetailId);
            getDocStatus(data.ActivitySummary.ActivitySubTypeId,data.ActivityDocuments.length>0?data.ActivityDocuments[0].DocumentStatusId:0);
             } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };
    const getDocStatus = async (ActivitysubTypeId,statusId) => {
        try {

            const response = await sbaAxios({
                url: `${getDocumentStatus}${ActivitysubTypeId}`,
                method: 'get',
            });
            const data = [
                {
                    "DocumentStatusId": 0,
                    "DocumentStatusName": "",
                    "DefaultFlag": false
                },...response
            ]
            setStatus(data);
            if(statusId ==0)
            {
            if(data.length>1)
            setDocumentStatusId({ DocumentStatusId:"-1", DocumentStatusName:"Select" })
            else
            setDocumentStatusId({ DocumentStatusId: data[0].DocumentStatusId, DocumentStatusName: data[0].DocumentStatusName })
            }
            else
            {
                var filtereditems=data.filter(item=>item.DocumentStatusId===statusId);
                            setDocumentStatusId(filtereditems[0]);
                      
            }
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    const getEntities = async (EntitytypeId) => {
        try {

            const response = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${EntitytypeId}&SearchString=${str}&activitySourceId=2`,
                method: 'get',
            });
            const data = response;
            setEntities(data);
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };
    const getCategoryData = async (subTypeID,typeid) => {
        try {

            const response = await sbaAxios({
                url: `${getcategory}${2}`,
                method: 'get',
            });
            const data =response.filter(item => item.ActivitySubTypeId !== -1);
            if(typeid!==1)
            {
                const subType=data.filter(item => item.ActivitySubType !== "General Note");
                setCategory(subType);
        }
           else
           {
            setcategoryFilter(data);
           } 
           
         
          const dt=  data.filter(item => item.ActivitySubTypeId === subTypeID);
          SetSelectedCategory(dt);
           setActivitySubTypeIds({ ActivitySubTypeId: dt[0].ActivitySubTypeId, ActivitySubType: dt[0].ActivitySubType });
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };
      

    const commentsChange = (event) => {
        setcomments(event.html);
    };

    const TypeDDChange = (e) => {
        SetEntitytype({ ActivityTypeId: e.value.ActivityTypeId, ActivityType: e.value.ActivityType });
        if(e.value.ActivityTypeId===1)
        {
            const subType=categoryFilter.filter(item => item.ActivitySubType === "General Note");
            setActivitySubTypeIds({ ActivitySubTypeId: subType[0].ActivitySubTypeId, ActivitySubType: subType[0].ActivitySubType })
        }
        else
            {
    const subType=categoryFilter.filter(item => item.ActivitySubType !== "General Note");
    setCategory(subType);
    if (selectedCategory && selectedCategory.length > 0) {
           if(selectedCategory[0]?.ActivitySubType==="General Note" && e.value.ActivityTypeId!==1)
           {
    setActivitySubTypeIds();
           }
           else
           {
            setActivitySubTypeIds({
                ActivitySubTypeId: selectedCategory[0]?.ActivitySubTypeId || '',
                ActivitySubType: selectedCategory[0]?.ActivitySubType || ''
            });
           }
}
   // setActivitySubTypeIds();
          }  
    }


  
    const activityEntityTypeDDChange = (e) => {
        const currentSelectAll = typeselected.value.some((i) => i.ActivityEntityType.trim() === "All");
        const nextSelectAll = e.value.some((i) => i.ActivityEntityType.trim() === "All");
        let value = e.value;
        const currentCount = typeselected.value.length;
        const nextCount = value.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            ActivityentityType.length - 1 === nextCount
        ) {
            value = ActivityentityType;
        } else if (
            nextCount < currentCount &&
            currentCount === ActivityentityType.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ActivityEntityType.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = ActivityentityType;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setTypeSelected({ value });
        setEntityTypeIds(value);
         const Id = value.map(item => item.ActivityEntityTypeId).join(',');
         getEntities(Id);
       
    };
    const subjectChange = (event) => {

        setsubject(event.target.value);
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
    }

    const CategoryDDChange = (e) => {
        setActivitySubTypeIds({ ActivitySubTypeId: e.value.ActivitySubTypeId, ActivitySubType: e.value.ActivitySubType })
    };
    const StatusDDChange = (e) => {

        setDocumentStatusId({ DocumentStatusId: e.value.DocumentStatusId, DocumentStatusName: e.value.DocumentStatusName })

    };
    const AssetDDChanged = (e) => {
        SetAssetId([...e.value]);
    };
    const gridValueFormatter = (params) => {
        return params.value;
    };
    const eventDateChange = (newDate) => {
        setselectedEventDate(newDate);

    }


    const DeleteButtonRenderer = (props) => {
        const handleDeleteClick = () => {
            if (props.data.DocumentId != 0) {
                SetExistingDocIds([...ExistingDocIds, props.data.DocumentId]);
                const updatedFiles = selectedDocuments.filter((item, index) => item.DocumentId !== props.data.DocumentId);
                setselectedDocuments(updatedFiles);
            }
            else {
                const updatedFiles = selectedDocuments.filter((item, index) => item.rowIndex !== props.data.rowIndex);
                setSelectedFiles(updatedFiles);
                setselectedDocuments(updatedFiles);
            }
            document.getElementById('fileInput').style.display = 'none';

            // Reset the file input value
            document.getElementById('fileInput').value = '';

            // Restore display
            document.getElementById('fileInput').style.display = 'block';
        }
        // Set display to none

        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };

    const columnDefs = [
        {
            field: "DocumentName",
            headerName: "File Name",
            //cellRenderer: HyperlinkRenderer,
            sort: "asc",
            pinned: "left",
            width: 400,
            filter: "agTextColumnFilter",
            valueFormatter: gridValueFormatter,
            tooltipField: 'FileName',
            editable: true,
        },
        {
            headerName: "",
            field: "Delete",
            maxWidth: 300,
            cellRenderer: DeleteButtonRenderer,
        }
    ];
    const NavigateBack = (e) => {
      const state = locationData?.state;
      const previousUrl = locationData?.state?.from;
      const activeTab = locationData?.state?.activeTab;
      history(previousUrl, {
        state: {
          maintainState: true,
          tab: activeTab
        },
      });
    };

    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1, resizable: true
    }



    const deleteSelectedDetails = () => {
        sbaAxios({ url: `${deleteActivity}${params.ActivityId}` }).then(res => {
            setTimeout(() => {
            SBNotify({
                Msg: "Selected Document Deleted Successfully", type: "success"

            });
        }, 500);
            setShowModal(false);
            NavigateBack();
         

        }).catch(error => {
            SBNotify({ Msg: error, type: "error" });
            setShowModal(false)
        })

    }



    const DeleteInvestment = () => {
        setShowModal(true);
    }
    const handleFileChange = (event) => {
    
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
            const updatedFiles = [];
            const startingRowIndex = 0;

            for (let i = 0; i < newFiles.length; i++) {
                const file = newFiles[i];
                const fileName = file.name;

                const lastDotIndex = fileName.lastIndexOf('.');
                const name = lastDotIndex >= 0 ? fileName.substring(0, lastDotIndex) : fileName;
                const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
                // Check if the extension is allowed
                // if (!allowedExtensions.includes(extension.toLowerCase())) {
                //     setFileError(`Unsupported file format: .${extension}`);
                //     continue; // Skip the rest if the format is invalid
                // }
                // setFileError("");

                const reader = new FileReader();

                reader.onload = function () {
                    if (reader.result) {
                        const arrayBuffer = reader.result;
                        const base64String = arrayBufferToBase64(arrayBuffer);
                        const rowIndex = startingRowIndex + i;
                        updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
                         setselectedDocuments([{ DocumentId: 0, DocumentName: fileName, rowIndex }]);
                        setSelectedFiles(updatedFiles);
                      
                    }
                };


                reader.readAsArrayBuffer(file);
            }


        }
    };

    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };
    const Documentdetails = (activityid) => {
       
        const DocumentData = selectedFiles.map((obj) => ({
            ActivityId: activityid,
            DocumentId: 0,
            DocumentName: obj.fileName,
            DocumentContent: obj.base64String,
            DocumentExtension: "."+ obj.extension,
            DocumentDate: selectedEventDate,
            RuleId: 0,
            IsPartnerLetter: PartnerLetter,
            IsEmailForwarded: false,
            IsReturnsProcessed: false,
            IsManagerLetter: ManagerLetter,
            ModifiedBy: 0,
            ActivitySourceId: 2,
            DocumentStatusId:documentStatusId.DocumentStatusId==="-1"?0:documentStatusId.DocumentStatusId
        }));

        sbaAxios({
            url: `${insertOrUpdateActivityDocument}`,
            method: "post",
            data: DocumentData,
        }).then((response) => {

        })

            .catch((error) => {
                console.error(error);
            });

    }
    const DeleteDocuments = () => {
        ExistingDocIds?.map((item) => {
            sbaAxios({
                url: `${DeleteDocument}${params.ActivityId},${item?.DocumentId}`
            })
                .then((res) => {
                    setSelectedFiles(selectedFiles.filter((items, index) => items?.DocumentId !== item))
                })
                .catch((error) => {
                    SBNotify({ Msg: error, type: "error" });
                });
        });
    }
    const saveInvestment = async (event) => {
        await gridRef.current.api.stopEditing();
        if(selectedDocuments[0]?.DocumentId && selectedDocuments[0]?.DocumentName)
        {
            setTimeout(() => {
                updateDocName(selectedDocuments[0]?.DocumentId, selectedDocuments[0]?.DocumentName)
    
            }, 100);

        }
         

        let saveSuccess = true;
        event.preventDefault();
        const activityXRefs = [];
        if (assetId.length > 0) {
            activityXRefs.push(
                ...assetId.map((asset) => ({
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: asset.ActivityEntityTypeId,
                    activityEntityType: asset.ActivityEntityType,
                    entityId: asset.EntityId,
                    entityName: asset.EntityName,
                }))
            );
        }

       
        const data = {
            "activitySummary": {
                "activityId": params.ActivityId,
                "activityTypeId": Entitytype.ActivityTypeId,
                "activitySubTypeId": ActivitySubTypeIds.ActivitySubTypeId,
                "activityName": subject,
                "activityDescription": comments ? comments.replace(/<\/?[^>]+(>|$)/g, "") : null,
                "activityDescriptionHtml": comments ? comments : null,
                "activityDate": selectedEventDate,
                "activitySourceId": 2,
                "documentStatusId": documentStatusId.DocumentStatusId==="-1"?0:documentStatusId.DocumentStatusId
            },
            "activityDetails":
            {
                "activityDetailId": activityDetailId,
                "activityId": params.ActivityId,
                "emailMessageId": "",
                "emailFrom": "",
                "emailTo": "",
                "mailCc": "",
                "emailSubject": "",
                "emailBody": "",
                "emailBodyHtml": "",
                "emailDate": selectedEventDate,
                "meetingDate": selectedEventDate,
                "isProcessed": isActivityProcessed
            },
            "activityXRefs": activityXRefs,
            "modifiedBy": 0,
        };

        if (!Entitytype.ActivityType) {
            SBNotify({ Msg: "Please Select Activity Type", type: "error" });
            saveSuccess = false;
        }
        else if (!ActivitySubTypeIds.ActivitySubTypeId || ActivitySubTypeIds.ActivitySubTypeId === -1) {
            SBNotify({ Msg: "Please Select Category Type", type: "error" });
            saveSuccess = false;
        }
        else if ((resulttrim == false) || (!subject) || (subject == "   ")) {
            SBNotify({ Msg: "Subject is Required", type: "error" });
            saveSuccess = false;
        }
        else if (assetId.length < 1) {
            SBNotify({ Msg: "Please Select Account/Contact", type: "error" });
            saveSuccess = false;
        }
        if(selectedFiles.length > 0)
        {
        if (ExistingDocIds.length > 0) {
            DeleteDocuments();
        }
    }
        if (saveSuccess) {

            sbaAxios({
                url: `${insertOrUpdateActivityDetails}`,
                method: "post",
                data: data,
            })
                .then((response) => {
                    if (response > 0) {
                        if (selectedFiles.length > 0) {
                            Documentdetails(params.ActivityId);
                        }
                    }
                    setTimeout(() => {
                    toast.success("Investor  Updated Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }, 500);
                NavigateBack();
                })
                .catch((error) => {
                    console.error(error);
                });
        };
    }
    const updateDocName = async (DocumentId, DocumentName) => {
        const updatedDocName = {
            "activityId":params.ActivityId,
            "documentId": DocumentId,
            "documentName":DocumentName,
           "modifiedBy":0 
        };

        try {
            const response = await sbaAxios({
                url: UpdateActivityDocumentname,
                method: 'post',
                data: updatedDocName,
            });

           
        } catch (error) {
            console.error("Error UpdateActivityDocumentname:", error.message);
            SBNotify({
                Msg: error.message,
                type: "error",
            });
        }
    };


    const onCellValueChanged = (params) => {
        const updatedDocuments = selectedDocuments.map(doc =>
            doc.id === params.data.id ? { ...doc, DocumentName: params.data.DocumentName } : doc
        );
        setselectedDocuments(updatedDocuments);
        //updateDocName(updatedDocuments[0].DocumentId, updatedDocuments[0].DocumentName)
    };
    return (
        <>
            <div>

                <TopBar label={"Investor Edit"} />
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div>
                        <div className="d-flex justify-content-end gap-2">
                            <button type="submit" className="s-sm-btn me-1" onClick={NavigateBack} > Cancel</button>
                            <button type="submit" className="p-sm-btn mx-1" onClick={saveInvestment}> Save </button>
                           {/* <button type="submit" className="p-sm-btn mx-1" > Save & Email</button>*/}
                            <button type="submit" className="p-sm-btn mx-1" onClick={DeleteInvestment}> Delete</button>

                        </div>
                        <br />
                        <div>
                            <div id="content" class="asset-detail-screen mainContentData">
                                <div className="row-md-12 d-flex gap-1">
                                    <div className="col-md-6">

                                        <div class="row detail p-3  m-0">

                                            <div className="row">

                                                <div className="col-md-4">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Activity Type <span className="mandatory">*</span>
                                                    </label>
                                                    <div>
                                                        <SBADropDown
                                                            className="w-85"
                                                            data={ActivityType}
                                                            value={Entitytype}
                                                            valueField="ActivityTypeId"
                                                            textField="ActivityType"
                                                            onChange={TypeDDChange}
                                                            filterable={true}
                                                            disable
                                                            
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Category <span className="mandatory">*</span>
                                                    </label>
                                                    <div>

                                                        <SBADropDown
                                                            className="w-85"
                                                            textField={"ActivitySubType"}
                                                            valueField={"ActivitySubTypeId"}
                                                            data={Category}
                                                            value={ActivitySubTypeIds}
                                                            onChange={CategoryDDChange}
                                                            filterable={true}
                                                            disabled={Entitytype?.ActivityTypeId==1}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-md-4">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Event Date
                                                    </label>
                                                    <div>
                                                    <SBDatePicker className="w-85" id="eventDate"
                                                        value={moment(selectedEventDate)}
                                                        onChange={eventDateChange}>
                                                    </SBDatePicker>

                                                    </div>

                                                </div>


                                            </div>


                                            <div className="row" style={{ marginTop: "20px" }}>
                                                <div className="col-md-6">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fs-12 fw-semibold"
                                                    >
                                                        Subject <span className="mandatory">*</span>
                                                    </label>
                                                    <input
                                                        className="w-125 input-default form-control"
                                                        type="text"
                                                        placeholder="Type here"
                                                        onChange={subjectChange}
                                                        value={subject}

                                                    //onKeyUp={loadOnEnter}
                                                    />

                                                </div>
                                                 
                                                <div className="col-md-6">
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fs-12 fw-semibold"
                                            >
                                                Document Status                                             </label>
                                            <SBADropDown
                                              className="w-85"
                                              textField={"DocumentStatusName"}
                                              valueField={"DocumentStatusId"}
                                              data={Status}
                                              value={documentStatusId}
                                              onChange={StatusDDChange}
                                              filterable={true}
                                              popupSettings={{ className: Modal ? `modalDD` : `` }}

                                            ></SBADropDown>

                                        </div>


                                            </div>
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fs-12 fw-semibold">
                                                    Description:
                                                </label>
                                                <SBAEditor id="editor" onChange={commentsChange} defaultContent={comments} editorHeight={300} setContent={setcomments}  ></SBAEditor>
                                            </div>
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div>
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fs-12 fw-semibold"
                                                    >
                                                        Tags:
                                                    </label>
                                                    <input
                                                        className="w-400 input-default form-control"
                                                        type="text"

                                                        onChange={subjectChange}
                                                        value={''}
                                                        //onKeyUp={loadOnEnter}
                                                        style={{ height: '60px' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row" style={{paddingLeft: "11px", paddingTop: "10px"}}>
                                                <label className="flex items-center space-x-2 cursor-pointer" >
                                                    <input
                                                    type="checkbox"
                                                    checked={isActivityProcessed}
                                                    onChange={()=>{
                                                        setIsActivityProcessed((prev)=> !prev)
                                                    }}
                                                    className="w-5 h-5"
                                                    />
                                                    <span style={{fontSize:"15px", marginLeft:"5px"}}>Is Processed</span>
                                                </label>
                                                </div>
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                        type="file"
                                                        id="fileInput"
                                                        className="input-hidden"
                                                        onChange={handleFileChange}
                                                    />

                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div className="ag-theme-alpine" style={{ width: '100%', height: '200px' }}>
                                                    <AgGridReact
                                                        columnDefs={columnDefs}
                                                        rowData={selectedDocuments}
                                                        defaultColDef={defaultColDef}
                                                        onCellValueChanged={onCellValueChanged}
                                                         ref={gridRef}
                                                    >
                                                    </AgGridReact>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-md-6">

                                        <div class="row detail p-3 m-0">
                                        <div className="row">

<div className="col-md-12">
    <label className="mb-1 ms-2 fw-semibold fs-12">
        Type
    </label>
    <div className="col-lg-12 mb-4">
        <SBAMultiSelectCheck
            className="w-75"
            data={ActivityentityType}
            dataItemKey="ActivityEntityTypeId"
            textField="ActivityEntityType"
            onChange={activityEntityTypeDDChange}
            value={EntityTypeIds}
            tags={
                EntityTypeIds?.length > 0
                    ? [
                        {
                            text: `${EntityTypeIds.filter(item=>item.ActivityEntityType.trim()!=="All").length} items selected`,
                            data: [...EntityTypeIds],
                        },
                    ]
                    : []
            }
            filterable={true}
        ></SBAMultiSelectCheck>
    </div>


</div>
</div>

                                         

                                            <div className="row"  >

                                                <div className="col-md-12">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Account/Contact
                                                    </label>
                                                    <div className="col-lg-12 mb-4">
                                                        <SBAMulticolumnCheck
                                                            data={Entities}
                                                            dataItemKey="EntityId"
                                                            textField="EntityName"
                                                            className="w-75"
                                                            onChange={AssetDDChanged}
                                                            value={assetId}
                                                            tags={
                                                                assetId?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${assetId.length} items selected`,
                                                                            data: [...assetId],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            filterable={true}
                                                        ></SBAMulticolumnCheck>
                                                    </div>


                                                </div>
                                            </div>

                                           

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showModal}  >
                <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
                    <Modal.Title>Do you want to delete the selected Document?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Document will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setShowModal(false) }}>Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { deleteSelectedDetails() }} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>
            <ToastContainer></ToastContainer>
        </>
    );
};
